<template>
  <div class="py-1">
    <div class="search-item-content">
      <div class="font-weight-bold d-flex align-items-center" style="line-height: 1.2;">
        {{ item.name }}
        <b-badge v-if="item.from_old_name" variant="info" class="ml-2" style="font-size: 70%;">New name</b-badge>
        <span class="ml-auto">
          <b-badge v-for="server in sortedServers" :key="server" :variant="getServerVariant(server)" class="ml-1" style="font-size: 70%; text-transform: capitalize;">
            {{ server }}
          </b-badge>
        </span>
      </div>
      <small class="text-muted d-block" style="margin-top: 2px;">{{ item.email }}</small>
    </div>
  </div>
</template>

<script>
  import Servers from '../../_servers'

  export default {
    props: {
      item: { required: true },
      searchText: { required: true }
    },
    computed: {
      sortedServers() {
        if (!this.item.servers) return []
        const order = ['gold', 'silver', 'red', 'blue', 'test']
        return [...this.item.servers].sort((a, b) => {
          return order.indexOf(a.toLowerCase()) - order.indexOf(b.toLowerCase())
        })
      }
    },
    methods: {
      getServerVariant(server) {
        let s = server.toLowerCase();
        if (s === 'gold') return 'warning'
        if (s === 'silver') return 'light'
        if (s === 'red') return 'danger'
        if (s === 'blue') return 'primary'
        return 'secondary'
      }
    }
  }
</script>
